export const VALIDATIONS = {
  PASSWORD_MIN_LENGTH: 8,
}
